import { render, staticRenderFns } from "./KerstmisGame.vue?vue&type=template&id=db038fe2&"
import script from "./KerstmisGame.vue?vue&type=script&lang=js&"
export * from "./KerstmisGame.vue?vue&type=script&lang=js&"
import style0 from "./KerstmisGame.vue?vue&type=style&index=0&id=db038fe2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports